/*eslint-disable */
import React, { FC, useEffect } from "react";
import { createUseStyles, useTheme } from "react-jss";
import clsx from "clsx";
import styles from "./styles";

interface Props {
  embedId: any;
  alt?: string;
  className?: any;
  style?: {};
  onClick?: (e: any) => void;
  onError?: (e: any) => void;
  width?: any;
  height?: any;
  top?: any;
  left?: any;
  iframeHeight?: any;
  iframeWidth?: any;
  children?: any;
}

const InstagramObject: FC<Props> = ({
  embedId,
  alt,
  className,
  style,
  onClick,
  onError,
  children,
  ...props
}: Props) => {
  const theme = useTheme();
  const useStyles = createUseStyles(styles);
  const classes = useStyles({ ...props });

  return (
    <button
      aria-label={alt}
      onClick={onClick}
      className={clsx(classes.image, className)}
      style={style}
    >
      <iframe
        aria-hidden="true"
        tabIndex={-1}
        className={classes.iframe}
        src={`https://www.instagram.com/p/${embedId}/embed`}
        frameBorder="0"
        scrolling="no"
      ></iframe>
      {children && <div className={classes.mediaIcon}>{...children}</div>}
    </button>
  );
};

export default InstagramObject;
try {
    // @ts-ignore
    InstagramObject.displayName = "InstagramObject";
    // @ts-ignore
    InstagramObject.__docgenInfo = { "description": "", "displayName": "InstagramObject", "props": { "embedId": { "defaultValue": null, "description": "", "name": "embedId", "required": true, "type": { "name": "any" } }, "alt": { "defaultValue": null, "description": "", "name": "alt", "required": false, "type": { "name": "string" } }, "className": { "defaultValue": null, "description": "", "name": "className", "required": false, "type": { "name": "any" } }, "style": { "defaultValue": null, "description": "", "name": "style", "required": false, "type": { "name": "{}" } }, "onClick": { "defaultValue": null, "description": "", "name": "onClick", "required": false, "type": { "name": "(e: any) => void" } }, "onError": { "defaultValue": null, "description": "", "name": "onError", "required": false, "type": { "name": "(e: any) => void" } }, "width": { "defaultValue": null, "description": "", "name": "width", "required": false, "type": { "name": "any" } }, "height": { "defaultValue": null, "description": "", "name": "height", "required": false, "type": { "name": "any" } }, "top": { "defaultValue": null, "description": "", "name": "top", "required": false, "type": { "name": "any" } }, "left": { "defaultValue": null, "description": "", "name": "left", "required": false, "type": { "name": "any" } }, "iframeHeight": { "defaultValue": null, "description": "", "name": "iframeHeight", "required": false, "type": { "name": "any" } }, "iframeWidth": { "defaultValue": null, "description": "", "name": "iframeWidth", "required": false, "type": { "name": "any" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/components/InstagramObject/InstagramObject.tsx#InstagramObject"] = { docgenInfo: InstagramObject.__docgenInfo, name: "InstagramObject", path: "src/shared/components/InstagramObject/InstagramObject.tsx#InstagramObject" };
}
catch (__react_docgen_typescript_loader_error) { }